<template>
  <div>
    <div>
      <span class="xbed-sub-title">开发队伍</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">蓝主人</BreadcrumbItem>
        <BreadcrumbItem>开发队伍</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form inline>
      <Row>
        <FormItem label="队伍名称" :label-width="84">
          <Input style="width: 200px" v-model="search.name"></Input>
        </FormItem>
        <FormItem label="负责人" :label-width="84">
          <Input style="width: 200px" v-model="search.leader"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="queryList">查找</Button>
        </FormItem>
      </Row>
      <Row>
        <FormItem>
          <Button type="primary" @click="() => editTeam()">新增队伍</Button>       
        </FormItem>
      </Row>
    </Form>
    <Table stripe :columns="column" :data="developerList"></Table>

    <Modal v-model="modalObj.show" ref="modal" :loading="true" :title="modalObj.title" ok-text="提交" @on-ok="modalObj.confirm">
      <Form :rules="ruleValidate" ref="form" :model="team"  v-if="modalObj.title === '新增队伍' || modalObj.title === '修改队伍'">
        <FormItem prop="leader" label="负责人" :label-width="80">
          <Input type="text" v-model="team.leader"></Input>
        </FormItem>
        <FormItem prop="name" label="队伍名称" :label-width="80">
          <Input type="text" v-model="team.name"></Input>
        </FormItem>
        <FormItem prop="city" label="区域" :label-width="80">
          <Input type="text" v-model="team.city"></Input>
        </FormItem>
      </Form>
      <p v-else>删除成功后无法恢复，确定删除吗？</p>
    </Modal>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import moment from 'moment';

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  mounted(){
    this.queryList()
  },
  data(){
    return{
      ruleValidate: {
        leader: [
          { required: true, message: "负责人不能为空", trigger: "blur" }
        ],
        name: [
          { required: true, message: "队伍名称不能为空", trigger: "blur" }
        ],
        city: [
          { required: true, message: "区域不能为空", trigger: "blur" }
        ]
      },
      canSubmit: true,
      search:{
        name: '',
        leader: ''
      },
      developerList: [],
      modalObj:{
        show: false,
        title: '新增队伍',
        confirm: () => {}
      },
      column: [
        {
          title: "ID",
          key: "id",
          align: "center",
        },
        {
          title: "负责人",
          key: "leader",
          align: "center",
        },
        {
          title: "队伍名称",
          key: "name",
          align: "center",
        },
        {
          title: "区域",
          key: "city",
          align: "center",
        },
        {
          title: "创建时间",
          key: "createdAt",
          align: "center",
          render:(h, param) => h( 'span', moment(param).format('YYYY-MM-DD'))
        },
        {
          title: "操作",
          align: "center",
          render:(h, param) => h('div', [
            h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => this.editTeam(param.row)
              }
            }, '修改'),
            h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: () => this.deleteTeam(param.row.id)
              }
            }, '删除')
          ])
        }
      ],
      team:{
        leader: '',
        name: '',
        city: ''
      }
    }
  },
  methods:{
    async queryList(){
      let {search} = this;
      this.developerList = (await API.omsAPI[this.env].php.getDevelopTeam(search)).data.retdata;
    },
    showModal(title){
      this.modalObj.title = title;
      this.modalObj.show = true;
    },
    editTeam(item){
      this.showModal(item ? '修改队伍' : '新增队伍');
      if(!item) item = {};
      let {name, leader, city} = item;
      this.team = {name, leader, city};
      this.modalObj.confirm = async () =>{
        let validResult;
        this.$refs.form.validate(valid => {
          validResult = valid
        });
        if (!validResult) {
          this.$refs.modal.buttonLoading = false;
          return;
        }
        let param = JSON.parse(JSON.stringify({...this.team, id: item? item.id : undefined}));
        
        let {retcode} = (await API.omsAPI[this.env].php.editDeveloperTeam(param)).data;
        if(retcode === '1'){
          window.location.reload();
          // if(!item.id){
          //   this.developerList.push(retdata);
          // }else{
          //   let index = this.developerList.findIndex(team => team.id === retdata.id);
          //   Object.assign(this.developerList[index], this.team);
          // }
          // this.modalObj.show = false;
        } else {
          this.$refs.modal.buttonLoading = false;
        }
      }
    },
    deleteTeam(id){
      this.showModal('删除队伍');
      this.modalObj.confirm = async () => {
        let {retcode} = (await API.omsAPI[this.env].php.delDeveloperTeam({id})).data;
        if(retcode === '1'){
          let index = this.developerList.findIndex(item => item.id === id);
          this.developerList.splice(index,1);
          this.modalObj.show = false;
        }
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
  .ivu-table-wrapper{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/blue-hoster/developer-team.vue